import { styled } from '@/stitches/index.js';
import { forwardRef, type ReactNode, type Ref } from 'react';

const Wrapper = styled('div', {
  '& > *': {
    display: 'inline-block',
    marginRight: '$60',
  },
  display: 'inline-block',
});

export const Segment = forwardRef(
  (
    {
      children,
      itemSpacingValue,
    }: {
      readonly children: ReactNode;
      readonly itemSpacingValue?: number | string;
    },
    ref: Ref<HTMLDivElement>,
  ) => {
    const spacingOverride = itemSpacingValue
      ? { marginRight: itemSpacingValue }
      : null;

    return (
      <Wrapper
        css={{ '& > *': { ...spacingOverride } }}
        ref={ref}
      >
        {children}
      </Wrapper>
    );
  },
);
